
import React from 'react';
import { Helmet } from 'react-helmet-async';
import TranslationAnalyzer from '@/components/dev/TranslationAnalyzer';

const TranslationAnalysisPage = () => {
  return (
    <>
      <Helmet>
        <title>Análisis de Traducciones - Herramientas de Desarrollo</title>
        <meta name="description" content="Herramienta para analizar y corregir problemas de localización en toda la aplicación" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <TranslationAnalyzer />
      </div>
    </>
  );
};

export default TranslationAnalysisPage;
